import { useMemo } from 'react'
import { LicensePlateVariant } from '@carsys/ui/src/LicensePlate/LicensePlateInputBase'
import { IProductWithState } from '@cbgms/api'

export const useLicensePlateVariant = (product: IProductWithState | null): LicensePlateVariant | undefined => {
  return useMemo(() => {
    if (!product?.ProductID && !product?.BaseID) {
      return undefined
    }
    let variantByBaseID = mapFromBaseID(product?.BaseID || '')
    if (!variantByBaseID) {
      variantByBaseID = mapFromProductID(product?.ProductID || '')
    }
    return variantByBaseID
  }, [product?.ProductID, product?.BaseID])
}

const mapFromBaseID = (baseID: string) => {
  switch (baseID) {
    case 'KPBLL': // Blauw Lang
      return LicensePlateVariant.NLBlue
    case 'KPBLLO': // Blauw lang luxe
      return LicensePlateVariant.NLBlue
    case 'KPBLSL': // Blauw snorfiets liggend
      return LicensePlateVariant.NLBlueMoped
    case 'KPBLSS': // Blauw snorfiets Staand
      return LicensePlateVariant.NLBlueMoped
    case 'KPBLSWL': // wit snorfiest liggend
      return LicensePlateVariant.NLWhiteSquare
    case 'KPBLTUSA': // blauw taxi USA
      return LicensePlateVariant.NLBlue
    case 'KPBLV': // Blauw liggend
      return LicensePlateVariant.NLBlueSquare
    case 'KPBLVO': // Blauw liggend luxe
      return LicensePlateVariant.NLBlueSquare
    case 'KPGEBL': // geel liggend bromfiets
      return LicensePlateVariant.NlYellowMoped
    case 'KPGEBS': // geel liggend bromfiets
      return LicensePlateVariant.NlYellowMoped
    case 'KPGEL': // geel lang
      return LicensePlateVariant.NLYellow
    case 'KPGELO': // geel lang luxe
      return LicensePlateVariant.NLYellow
    case 'KPGEM': // geel rechthoeking motor
      return LicensePlateVariant.NLYellowSquare
    case 'KPGEMO': // geel rechthoeking motor luxe
      return LicensePlateVariant.NLYellowSquare
    case 'KPGEUSA': // geel usa
      return LicensePlateVariant.NLYellow
    case 'KPGEV': // geel vierkant
      return LicensePlateVariant.NLYellowSquare
    case 'KPGEVO': // geel vierkant  luxe
      return LicensePlateVariant.NLYellowSquare
    case 'KPGRBSL': // groen brommer liggend
      return LicensePlateVariant.NLGreenSquare
    case 'KPGRBSS': // groen lang staand
      return LicensePlateVariant.NLGreenSquare
    case 'KPGRL': // groen lang
      return LicensePlateVariant.NLGreen
    case 'KPGRLO': // groen lang luxe
      return LicensePlateVariant.NLGreen
    case 'KPGRM': // groen motor
      return LicensePlateVariant.NLGreenSquare
    case 'KPGRMO': // groen motor luxe
      return LicensePlateVariant.NLGreenSquare
    case 'KPGRUSA': // groen USA
      return LicensePlateVariant.NLGreen
    case 'KPGRV': // groen vierkant
      return LicensePlateVariant.NLGreenSquare
    case 'KPGRVO': // groen vierkant luxe
      return LicensePlateVariant.NLGreenSquare
    case 'KPOBLFL':
      return LicensePlateVariant.NLBlue
    case 'KPOBLFLO':
      return LicensePlateVariant.NLBlue
    case 'KPOBLFM':
      return LicensePlateVariant.NLBlue
    case 'KPOBLFUSA':
      return LicensePlateVariant.NLBlue
    case 'KPOBLFV':
      return LicensePlateVariant.NLBlue
    case 'KPOBLFVO':
      return LicensePlateVariant.NLBlue
    case 'KPOGEL':
      return LicensePlateVariant.NLYellow
    case 'KPOGELR':
      return LicensePlateVariant.NLYellow
    case 'KPOGEV':
      return LicensePlateVariant.NLYellow
    case 'KPWIBSS': // wit snorfiets
      return LicensePlateVariant.NLWhiteSquare
    case 'KPWIL': // wit
      return LicensePlateVariant.NLWhite
    case 'KPWILO': // wit luxe
      return LicensePlateVariant.NLWhite
    case 'KPWIM': // wit motor
      return LicensePlateVariant.NLWhiteSquare
    case 'KPWIV': // wit vierkant
      return LicensePlateVariant.NLWhiteSquare

    // AX specific plates:
    case '0691343':
      return LicensePlateVariant.NLYellow
    case '1363985':
      return LicensePlateVariant.NLYellow
    case '1362022':
      return LicensePlateVariant.NLYellow
    case 'FUNGRL':
      return LicensePlateVariant.NLGreen
    case 'KPBLLMOTOR':
      return LicensePlateVariant.NLBlueMoped
    case 'FUNGEL':
      return LicensePlateVariant.NLYellow
    case 'FUNROL':
      return LicensePlateVariant.NLYellow
    case 'FUNBLL':
      return LicensePlateVariant.NLBlue
    case 'KPGELV':
      return LicensePlateVariant.NLYellowSquare
    case 'KPOBLLV':
      return LicensePlateVariant.NLBlueSquare
    case 'KPOBLLVO':
      return LicensePlateVariant.NLBlueSquare
    case 'FUNZWL':
      return LicensePlateVariant.NLWhite
    case 'KPGELL':
      return LicensePlateVariant.NLYellow
    case 'KPZAKLANG':
      return LicensePlateVariant.NLYellow
    case 'KPZAKVIERKANT':
      return LicensePlateVariant.NLYellowSquare
    case 'KPOBLLL':
      return LicensePlateVariant.NLBlue
    case 'KPGELM':
      return LicensePlateVariant.NLYellowSquare
    case 'KPOBLLLO':
      return LicensePlateVariant.NLBlue
    case 'KPOBLLUSA':
      return LicensePlateVariant.NLBlue
  }
  return undefined
}

const mapFromProductID = (productID: string) => {
  switch (productID) {
    case '000303061':
      return LicensePlateVariant.NLYellow
    case '000303094':
      return LicensePlateVariant.NLYellow
    case '000575003':
      return LicensePlateVariant.NLYellow
    case '001888458':
      return LicensePlateVariant.NLYellow
    case '002167044':
      return LicensePlateVariant.NLYellow
    case '002167077':
      return LicensePlateVariant.NLYellowSquare
    case '002167099':
      return LicensePlateVariant.NLYellowSquare
    case '002167110':
      return LicensePlateVariant.NLYellow
    case '002167132':
      return LicensePlateVariant.NLYellowSquare
    case '002167154':
      return LicensePlateVariant.NLWhite
    case '002167165':
      return LicensePlateVariant.NLWhiteSquare
    case '002167176':
      return LicensePlateVariant.NLWhite
    case '002167209':
      return LicensePlateVariant.NLWhite
    case '002167220':
      return LicensePlateVariant.NLWhite
    case '002167231':
      return LicensePlateVariant.NLYellow
    case '002207139':
      return LicensePlateVariant.NLYellow
    case '002252591':
      return LicensePlateVariant.NLBlue
    case '002252613':
      return LicensePlateVariant.NLBlue
    case '002252635':
      return LicensePlateVariant.NLBlueSquare
    case '002252646':
      return LicensePlateVariant.NLBlueSquare
    case '002252822':
      return LicensePlateVariant.NLBlue
    case '002779414':
      return LicensePlateVariant.NLBlue
    case '003458620':
      return LicensePlateVariant.NLGreen
    case '003544541':
      return LicensePlateVariant.NLGreen
    case '004161080':
      return LicensePlateVariant.NLYellowSquare
    case '004161157':
      return LicensePlateVariant.NLYellowSquare
    case '004161168':
      return LicensePlateVariant.NLBlueMoped
    case '004161179':
      return LicensePlateVariant.NLBlueMoped
    case '004161190':
      return LicensePlateVariant.NLYellow
    case '004161201':
      return LicensePlateVariant.NLYellow
    case '004161212':
      return LicensePlateVariant.NLWhiteSquare
    case '004161223':
      return LicensePlateVariant.NLWhiteSquare
    case '005270518':
      return LicensePlateVariant.NLYellow
    case '005323109':
      return LicensePlateVariant.NLYellow
    case '005363479':
      return LicensePlateVariant.NLYellow
    case '006971415':
      return LicensePlateVariant.NLYellow
    case '012916255':
      return LicensePlateVariant.NLYellowSquare
    case '020865977':
      return LicensePlateVariant.NLYellow
    case '007041221':
      return LicensePlateVariant.BEWhiteRed
    case '006381738':
      return LicensePlateVariant.BEWhiteRed
  }
  return undefined
}
